// extracted by mini-css-extract-plugin
module.exports = {"timeContainer":"style_timeContainer__1jtnK"};